export default "__VITE_ASSET__Wk0O_1Qu__"